import { NgModule } from '@angular/core';
import { BADGE_FEATURE_LAZY, BADGE_UI_REQUEST_COUPON_LAZY } from '@badge/const';
import { BadgesComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        [BADGE_FEATURE_LAZY]: {
          module: () => import('./lazy/badge-feature.module').then((m) => m.BadgeFeatureModule),
        },
        [BADGE_UI_REQUEST_COUPON_LAZY]: {
          module: () => import('./lazy/request-coupon.module').then((m) => m.RequestCouponModule),
          cmsComponents: [BadgesComponents.SdCMSRequestCouponFormComponent],
        },
      },
    }),
  ],
})
export class SdvorBadgeShellModule {}
